import {
  chipClasses,
  Stack as MuiStack,
  StackProps,
  styled,
  Typography,
  TypographyProps,
} from '@mui/material';

import { generateClasses } from '../../../utils/helper';
import ZoomUsIcon from '../../../icons/ZoomUsIcon';
import Tag from '../../../components/Tag';

export const courseCardClasses = {
  ...generateClasses('CourseWidget', [
    'root',
    'header',
    'zoomUsIcon',
    'courseCode',
    'content',
    'courseTitle',
    'userAvatarSkeleton',
    'adminNameSkeleton',
    'footer',
    'role',
    'calendarIcon',
  ]),
};

export const Root = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'grid',
  gridTemplateAreas: '"header" "content" "footer"',
  gridTemplateColumns: '1fr',
  gridTemplateRows: `${theme.spacing(9.25)} 1fr ${theme.spacing(9)}`,
  justifyItems: 'stretch',
  gap: theme.spacing(0.75),
  borderRadius: 6,
  backgroundImage: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[50]} 100%)`,
  border: `1px solid ${theme.palette.grey[300]}`,
  textAlign: 'left',
}));

export const Header = styled('div')(({ theme }) => ({
  gridArea: 'header',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2.25, 3.75),
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
}));

export const StyledZoomUsIcon = styled(ZoomUsIcon)(({ theme }) => ({
  width: 21,
  height: 21,
  marginRight: theme.spacing(1),
}));

export const CourseCode = styled((props: TypographyProps) => (
  <Typography variant="titleMedium" component="h5" {...props} />
))(({ theme }) => ({
  color: theme.palette.primary[900],
}));

export const Content = styled('div')(({ theme }) => ({
  gridArea: 'content',
  padding: theme.spacing(2.25, 3.75),
}));

export const CourseTitle = styled((props: TypographyProps) => (
  <Typography variant="h6Bold" component="h5" {...props} />
))(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.grey[900],
  marginBottom: theme.spacing(2.25),
}));

export const AdminName = styled((props: TypographyProps) => <Typography variant="textSmMedium" {...props} />)(
  ({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.grey[700],
  })
);

export const Footer = styled('div')(({ theme }) => ({
  gridArea: 'footer',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2.25, 3.75),
  borderTop: `1px solid ${theme.palette.grey[200]}`,
}));

export const Dates = styled((props: TypographyProps) => <Typography variant="textXsRegular" {...props} />)(
  ({ theme }) => ({
    color: theme.palette.grey[800],
  })
);

export const Role = styled(Tag)(({ theme }) => ({
  marginLeft: 'auto',
  padding: theme.spacing(0.25, 1.5),
  [`& .${chipClasses.label}`]: {
    fontSize: theme.typography.pxToRem(10),
  },
}));

export const Stack = styled((props: StackProps) => (
  <MuiStack direction="row" alignItems="center" {...props} />
))(({ theme }) => ({}));
